import { createReducer, on } from '@ngrx/store';
import {
  loadClientList,
  loadClientListSuccess,
  loadClientListFailure,
  clearClientList,
} from './client.actions';

export interface ClientState {
  data: any[] | null;
  loading: boolean;
  error: any;
}

export const initialState: ClientState = {
  data: null,
  loading: false,
  error: null,
};

export const clientReducer = createReducer(
  initialState,
  on(loadClientList, (state) => ({ ...state, loading: true, error: null })),
  on(loadClientListSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadClientListFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(clearClientList, (state) => ({ ...state, data: null }))
);
